export default __webpack_public_path__ + "static/media/scout_logo.f041ec12.png";